import PropTypes from "prop-types";

import { alignItems } from "../../../../../consts";
import { t } from "../../../../../services";

import { FlexContainers, WrapperContainer } from "../../../../../components";
import { IconWrapper, ReleaseNoteOptionWrapper, Title } from "./styled";

export const ReleaseNoteOption = ({ title, icon, isActive, Component }) => {
  return (
    <ReleaseNoteOptionWrapper
      Container={FlexContainers.FlexRowStart}
      gap={8}
      width={"100%"}
      isActive={isActive}>
      {icon ? <IconWrapper Container={FlexContainers.FlexColumn}>{icon}</IconWrapper> : null}
      <WrapperContainer
        Container={FlexContainers.FlexRowBetween}
        alignItems={alignItems.center}
        width={"100%"}
        minHeight={40}>
        <Title>{t(title)}</Title>

        {Component ? Component : null}
      </WrapperContainer>
    </ReleaseNoteOptionWrapper>
  );
};

ReleaseNoteOption.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  Component: PropTypes.node,
  isActive: PropTypes.boolean
};
